import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const useEventFilterTypes: any = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["filters"],
    queryFn: getData,
  });


  let filterTypes: { reg_types: any[], states: any[], types: any[], subtypes: any[] } = { reg_types: [], states: [], types: [], subtypes: [] };

  if (data) {
    filterTypes.reg_types = data.reg_types
    filterTypes.states = data.states

    data.types.forEach((element: any) => {
      filterTypes.types.push({id: element.type, name:element.type})

      element.subtypes?.forEach((subtype: any) => {

        if (!filterTypes.subtypes.find((sb) =>sb.id == subtype)) {
          filterTypes.subtypes.push({id: subtype, name:subtype})
        }

      });
    });
  }


  return [filterTypes, isLoading, error];
};

const getData = async () => {
  const response = await axios.get(`/events/filters/`);
  return response.data;
};

export default useEventFilterTypes;

